import { getUserMaps, updateUserIdNameMap } from './userId';

let clientIdToName;
let haveM2MClains = false;
let lockRequest = false;
let claimsSetup = false;

export const setupClaims = (claim) => {
	claimsSetup = true;
	haveM2MClains = claim;
};

export const parseArrayClientIdToClientName = async (data) => {
	if (!data) {
		return data;
	}
	data.forEach(async (value) => {
		return await parseClientIdToClientName(value);
	});

	return data;
};

export const parseClientIdToClientName = async (data) => {
	if (!data || !claimsSetup) {
		return data;
	}
	if (!clientIdToName) {
		await getClientIdList();
	}
	const keys = data['createdBy']
		? ['createdBy', 'modifiedBy']
		: ['created_by', 'modified_by'];
	const clientId = data[keys[0]];
	const validObjectID = /^[0-9a-fA-F]{24}$/;
	if (!validObjectID.test(clientId)) {
		return data;
	}
	data[keys[0]] = clientIdToName[clientId] || clientId;
	if (validObjectID.test(data[keys[1]])) {
		data[keys[1]] = clientIdToName[clientId] || clientId;
	}
	data.groupedDocument = true;
	return data;
};

export const getClientIdList = async () => {
	if (lockRequest) {
		while (!clientIdToName) {
			await new Promise((r) => setTimeout(r, 500));
		}
		return;
	}
	try {
		await updateUserIdNameMap();
		clientIdToName = getUserMaps();
	} catch (error) {
		console.log('Problem trying to get M2M tokens', error);
	}
	lockRequest = false;
};

export const cleanApiKeysCache = () => {
	clientIdToName = undefined;
};
